<body>
    <div class="main-wrapper">
        <div class="main-content">
            <header>

                <div class="head-line">

                    <p>Incentive Page</p>


                </div>
                <div class="user-wrapper">
                    <p>{{storedData.agencyRefId.agencyName}}</p>

                    <div>
                        <img class="log1"
                            [src]="this.storedData.agencyRefId.logo?this.storedData.agencyRefId.logo:'../../../../assets/../../assets/images/user1.jpeg'">
                    </div>
                </div>
            </header>


            <!-- <div class="header2">
    
                <a
                *ngFor="let caseType of  this.selectedCases; let i = index"
                class="btn"
                [ngClass]="{ 'active': selectedCase === caseType.name }"
                (click)="selectCase(caseType.name)"
               
              >
                {{ caseType.name }} <span>{{ caseType.count }}</span>
              </a>
    
            </div> -->

            <div class="header3">

                <!-- <div class="dropdown-container">
                    <label for="rows">Rows</label>
                    <div class="middle-b"></div>
                    <select id="rows"  (change)="onTableSizeChange($event)">
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="150">150</option>
                        <option value="1000">1000</option>

                    </select>
                </div> -->


                <!-- <div class="dropdown-container" style="    width: 196px;">
                    <label for="rows">Initiated By</label>
                    <div class="middle-b"></div>
                    <select id="rows"  (change)="onInitiatedByChange($event)" >
                        <option *ngFor="let item of staffDetails" [value]="item._id">{{item.name}}</option>
                        
                    </select>
                </div> -->

                <input type="month" class="form-control" style="width: 200px;" [(ngModel)]="currentMonthForListCases"
                    [ngModelOptions]="{standalone: true}" (change)="listIncentiveCases()">


                <div class="fill-sea">
                    <!-- <div class="search-m">
                        <input type="text" id="searchQueryInput2" placeholder="Search here..."    [(ngModel)]="searchQuery"  (input)="listIncentiveCases()">
                        <button type="submit" id="searchQuerySubmit"><svg viewBox="0 0 24 24"
                                style="width: 24px; height: 24px;">
                                <path fill="#666666"
                                    d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z">
                                </path>
                            </svg>
                        </button>
                    </div> -->


                </div>
                <!-- <div class="form-group"> -->

                <!-- </div> -->

                <a class="btn" (click)='AllocationFlag=true;setValue()'><img src="../../assets/images/autorenew.png">
                    Settings</a>
                <a class="active btn" (click)="downLoadPdf()">

                    Download

                </a>


            </div>
            <!-- <ng-multiselect-dropdown class="dropdown-one" [settings]="dropdownSettings" [data]="cases"  [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedStatuses"  >
           </ng-multiselect-dropdown> -->
            <!-- <label >vhvhvh</label> -->
            <!-- <ng-multiselect-dropdown class="dropdown-two" [settings]="productSettings" [data]="storedData.products"  [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedProducts"   (onDropDownClose)="ListCases()" >
            </ng-multiselect-dropdown>   -->

            <div class="headertest">
                <ng-multiselect-dropdown class="dropdown-one" [settings]="dropdownSettingslocation"
                    [data]="Alllocations" [(ngModel)]="selectedlocations" [ngModelOptions]="{ standalone: true }"
                    (onSelect)="Pushlocation($event)" (onDeSelect)="Pushlocation($event)">
                </ng-multiselect-dropdown>
            </div>

            <main class="main-2">

                <div class="container">
                    <div class="projects">


                        <div class="two-screen">

                            <div class="mainside2">
                                <table class="table-main">
                                    <thead>


                                        <tr>

                                            <th style="cursor: pointer;width:2%" (click)="sortTable('createdAt')">Sl No
                                                <span *ngIf="sortField === 'createdAt'">
                                                    {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                                </span></th>
                                            <th style="cursor: pointer;width:13%" (click)="sortTable('clientName')">
                                                Company<span *ngIf="sortField === 'clientName'">
                                                    {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                                </span></th>
                                            <th style="cursor: pointer;width:15%" (click)="sortTable('location')">
                                                location<span *ngIf="sortField === 'location'">
                                                    {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                                </span></th>
                                            <th style="cursor: pointer;width:25%" (click)="sortTable('status')">
                                                Status<span *ngIf="sortField === 'status'">
                                                    {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                                </span></th>

                                            <th style="cursor: pointer;width:25%" (click)="sortTable('status')">Telle
                                                Caller<span *ngIf="sortField === 'status'">
                                                    {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                                </span></th>


                                            <th style="cursor: pointer;width:25%">Incentive

                                            </th>
                                            <!-- <th  style="cursor: pointer;width:8%"  (click)="sortTable('updatedAt')">Updated date<span *ngIf="sortField === 'updatedAt'">
                                                {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                              </span></th>
  -->
                                            <!-- <th  style="cursor: pointer;width:8%"  (click)="sortTable('updatedBy')">Updated by<span *ngIf="sortField === 'updatedBy'">
                                                {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                              </span></th>


                                              <th  (click)="sortTable('currentAllocation')" style="cursor: pointer;width:7%">Current Allocation <span *ngIf="sortField === 'clientRefId'">
                                                {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                              </span></th>

                                              <th  style="cursor: pointer;width:15%"  (click)="sortTable('products')">Products<span *ngIf="sortField === 'updatedAt'">
                                                {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                              </span></th>
                                            <th class="med-width"  style="cursor: pointer;width:10%"  (click)="sortTable('status')">Status<span *ngIf="sortField === 'status'">
                                                {{ sortOrder === 'asc' ? '▲' : '▼' }}
                                              </span></th> -->
                                            <th class="right-align" style="width:8%">Actions </th>

                                            <!-- <th class="right-align move-right"><img src="img/Ellipse 92.svg"></th> -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let eachCase of this.showingCases | paginate : pagingConfig; let i = index;
                                     " (dblclick)="ClientDetail('EDIT',eachCase); $event.stopPropagation()">

                                            <td style="width:8%">
                                                <p class="name-one">{{ i+1}}</p>
                                            </td>

                                            <td style="width:8%">
                                                <p class="name-one" (click)="copyText(eachCase.clientName)" title="Click to copy">{{eachCase.clientName}}</p>
                                            </td>
                                            <td style="width:6%">
                                                <p class="name-one" (click)="copyText(eachCase.location)" title="Click to copy">{{eachCase.location}}</p>

                                            </td>
                                            <td style="width:10%"><button class="status-one"
                                                    [ngClass]="getStatusClass(eachCase.status)" (click)="copyText(eachCase.status)" title="Click to copy">{{eachCase.status}}



                                                </button></td>


                                            <td style="width:8%">
                                                <p class="name-one" (click)="copyText(eachCase.teleCallerId.name)" title="Click to copy">
                                                    {{eachCase.teleCallerId?.name || ''}} </p>
                                            </td>

                                            <td style="width:10%">
                                                <div class="form-group">
                                                    <select class="select-al"
                                                        [(ngModel)]="eachCase.incentiveTeleCallerId"
                                                        [ngModelOptions]="{standalone: true}"
                                                        [compareWith]="compareObjects">
                                                        <option *ngFor="let each of userTypesTelleCaller"
                                                            [ngValue]="each">
                                                            {{ each.name }}
                                                        </option>
                                                    </select>

                                                </div>
                                            </td>
                                            <td class="right-align" style="width:8%">
                                                <div class="pop-over" style="cursor: pointer;">
                                                    <img src="../../assets/images/eye-open (1).png"
                                                        style="filter: invert(1) brightness(0);"
                                                        (click)="ClientDetail('EDIT',eachCase)">&nbsp;&nbsp;&nbsp;&nbsp;
                                                    <!-- <img src="../../assets/images/Delete.png"       *ngIf="!(this.storedData.userType[0].userType!=='Client Admin' && tab=='All Cases')"

                                                    style="filter: invert(16%) sepia(99%) saturate(7493%) hue-rotate(356deg) brightness(95%) contrast(108%);"
                                                    (click)="disable(eachCase)"> -->

                                                    <button class="btn-prime"
                                                        (click)="update1(eachCase)">Clear</button>&nbsp;

                                                    <button class="btn-prime" (click)="update(eachCase)">Update</button>
                                                </div>
                                            </td>
                                        </tr>







                                    </tbody>

                                </table>
                                <pagination-controls previousLabel="Prev" nextLabel="Next"
                                    (pageChange)="onTableDataChange($event)">
                                </pagination-controls>
                                <span style="    margin-left: 76px;">{{currentCount }} Of {{ total}}</span>

                            </div>

                            <!--float button-->
                            <div id="" class="overlay" *ngIf="AllocationFlag">
                                <div class="popup-ins" id="popup-ins1">
                                    <div class="ins-f" id="ins-f1">
                                        <h2>Settings Values</h2>

                                        <form class="staff-form mt-2" [formGroup]="settingsForm">

                                            <div class="row">
                                                <div class="col-lg-12 col-xs-12 col-sm-6">
                                                    <div class="form-group">
                                                        <input type="month" class="form-control"
                                                            formControlName="currentMonth" (change)="setValue()">

                                                    </div>
                                                </div>
                                            </div>






                                            <div class="row">
                                                <div class="col-lg-12 col-xs-12 col-sm-6">
                                                    <div class="form-group">
                                                        <label>Target Count </label>
                                                        <input type="number" class="form-control"
                                                            formControlName="targetCount">



                                                    </div>
                                                    <div class="form-group">
                                                        <label>Label2 </label>
                                                        <input type="number" class="form-control"
                                                            formControlName="label2">



                                                    </div>
                                                    <div class="form-group">
                                                        <label>Label3</label>
                                                        <input type="number" class="form-control"
                                                            formControlName="label3">



                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>

                                    <div class="ins-footer">
                                        <button class="btn-sec" (click)="AllocationFlag=false">Back</button>
                                        <button class="btn-prime" (click)="submit()">Submit</button>
                                    </div>

                                </div>
                            </div>

                            <!-- </div> -->



                        </div>

                    </div>

                </div>


            </main>

        </div>
    </div>

    <div class="footer-section2">

        <img src="../../assets/images/accruon-footer (2).png">
    </div>

</body>